export const sortFields = [
	'id',
	'usageName',
	'createdAt',
	'updatedAt',
	'takeoffTypeRef',
	'wastage',
] as const;
